import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';

import { normalizeClasses } from '../lib';
import { AvailableClassesMap, CompleteTeacherClass } from '../types';

interface ClassState {
  availableClasses: CompleteTeacherClass[] | null;
  availableClassesMap: AvailableClassesMap | null;
}

const initialState: ClassState = {
  availableClasses: null,
  availableClassesMap: null,
};

export const classesSlice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    setAllClasses: (state, action: PayloadAction<CompleteTeacherClass[]>) => {
      state.availableClasses = action.payload;
      state.availableClassesMap = normalizeClasses(action.payload);
    },
  },
});

export const { setAllClasses } = classesSlice.actions;

export const useAvailableClasses = () =>
  useAppSelector((state) => state.teacherClasses.availableClasses);

export const useAvailableClassesMap = () =>
  useAppSelector((state) => state.teacherClasses.availableClassesMap);

export const teacherClassesReducer = classesSlice.reducer;
